import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,
  ...(IS_ADMIN
    ? {
      FOOTER_TEXT: '#b0b0b0',
      LINK_COLOR: '#1589ee',
      HEADER_INFO_DASHBOARD_COLOR: '#fff',
      MENU_BORDER_COLOR: '#1589ee',
      RESELLER_SELECT_COLOR_FIRST: '#000',
      RESELLER_SELECT_COLOR_LAST: '#000',
      SELECTED_MENU_TITLE: '#1589ee',
      NON_SELCTED_SVG_COLOR: '#fff',
      CHIP_BG: '#fff',
      LOGIN_BACKGROUND: '#455560',
      SELECTED_MENU_BG: '',
      PRIMARY_MAIN: '#f0f2f2',
      HEADER_COUNT_TEXT: '#455560',
      PRIMARY_CONTRAST: '#455560',
      LOGIN_INPUTBG: '#fff',
      PRIMARY_BORDER: '#ccc',
      GREY: '#999',
      DAILY_LOG_GRAPH_BORDER: '#919191',
      NORMAL_LINK: '#47545e',
      MENU_TITLE: '#fff',
      LOGOUT_BUTTON: '#1589ee',
      USER_NAME_COLOR: '#fff',
      MODAL_TEXT: '#797979',
      MODAL_HEADING: '#575757',
      LIST_TEXT: '#455560',
      HEADER_LIST_TEXT: '#455560',
      LIGHT_BORDER: '#2d2b2b',
      MENU_BACKGROUND: '#061c3f',
      SECONDARY_CONTRAST: '#fff',
      WHITE: '#fff',
      INPUT_BACKGROUND: '#ffffff',
      RED: '#ff0000',
      BLACK: '#000',
      BACKGROUND: '#fff',
      BLACK_THREE: '#373737',
      RED_TWO: '#d34343',
      GREEN: '#32cd32',
      GREEN_TWO: '#97AE46',
      GREY_ELEVEN: '#777070',
      GREY_TWELVE: '#c3c3c3',
      BLACK_FOUR: '#333333',
      GRAPH_BLACK: '#212121',
      CHART_BLUE: '#00e2ff',
      WARNING: '#ffff00',
      GREY_DATA: '#696969',
      HEADER_COLOR: '#061c3f',
      DOCUMENT_LINE: '#2C3249',
      DISABLED_COLOR: '#889ccc',
      RADIO_BACKGROUND: '#f0f2f2',
      FORM_COLOR: '#191e22',
      SUGGESTED_COLOR: '#00b7a0',
      BODY_BACKGROUND: '#f0f2f2',
      CHECKBOX_TICK: '#1589ee',
      PAGINATION_ALTERNATE_BACKGROUND: '#efefef',
      PAGINATION_COLOR: '#fff',
      SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
      MAP: {
        LIGHT_BLACK: '#424D66',
        LIGHTER_BLACK: '#424D66',
        BLACK: '#424D66',
        GREY: '#d1d1d1',
        LIGHT_GREY: '#d1d1d1',
        LIGHTER_GREY: '#d1d1d1',
        WATER: '#2B364F',
        ROAD: '#37425C',
      },
      LOGIN_BUTTON: '#1589ee',
      BACKGROUND_MENU: '#455560',
      TITLE_COLOR: '#191e22',
      INPUT_COLOR: '#000',
      INPUT_FOCUS: '#1589ee',
      TABLE_ROW_COLOR: '#39434c',
      SORT_ICON: '#1589ee',
      PAGINATION_HEADER: '#455560',
      HEADER_TEXT: '#fff',
      PAGINATION_BORDER: '#f0f2f2',
      RESET_BUTTON: '#47545e',
      ACTION_BORDER: '#455560',
      PRIMARY_BUTTON_TEXT: '#fff',
      FORM_INPUT_BG: '#f0f2f2',
      MULTISELECT_BACKGROUND: '#455560',
      MULTISELECT_LABEL: '#f0f2f2',
      FORM_BACKGROUND: '#fff',
      RESET_BACKGROUND: '#455560',
      RESET_COLOR: '#ffffff',
      CHECKBOX_BORDER: '#d1d3d6',
      SELECT_ACTIONS: '#444',
      SECONDARY_BORDER: '#d0d4d7',
      TAB_HIGHLIGHT: '#1589ee',
      TAB_BOTTOM_BORDER: '#9cc663',
      TAB_HIGHLIGHT_BACKGROUND: '#fff',
      ACCORDION_BACKGROUND: '#fff',
      USER_LOGO_BACKGROUND: '#455560',
      USER_LOGO_COLOR: '#ffffff',
      POLICIES_BACKGROUND: '#fff',
      INPUT_BORDER: '#8A8B8C',
      TERNARY_BORDER: '#8A8B8C',
      ALERT_COLOR: '#ce1e51',
      ALERT_BACKGROUND: '#2a3135',
      DASHBOARD: {
        CARD: '#fff',
        COLOR: '#000',
      },
    }
    : {}),
  ...(IS_ADMIN
    ? {}
    : {
      PRIMARY_MAIN: '#fff',
      BACKGROUND: '#efefef',
      HEADER_COUNT_TEXT: '#373737',
      PRIMARY_CONTRAST: '#373737',
      PUBLIC_HEADERCOLOR: '#061c3f',
      LANGUAGE_SWITCH: '#1589ee',
      HEADER_TEXT: '#f4f6f9',
      BODY_BACKGROUND: '#fff',
      MODAL_BORDER: '#d9d9d9',
      MODAL_LINK: '#1589ee',
      LINK_COLOR: '#1589ee',
      HEADER_COLOR: '#1589ee',
      CHECKBOX_TICK: '#000',
      ACTIVE_ROW: 'rgba(21,137,238,0.31)',
      PAGINATION_COLOR: '#000',
      SELECTED_AREA: 'rgba(32, 177, 232, 0.3)',
      BACKGROUND_MENU: '#f4f6f9',
      INPUT_BORDER: '#ccc',
      USER_LOGO_BACKGROUND: '#fff',
      USER_LOGO_COLOR: '#1589ee',
    }),
  SECONDARY_MAIN: '#1589ee',
  MODAL_BACKGROUND: '#fff',
  PAGINATION_BACKGROUND: '#fff',
  RANGE_PICKER: {
    CELL_BG: '#dfdfdf',
    CELL_HOVER_BG: '#bbbbbb',
  },
};
export const fonts = ['Source Sans Pro', 'sans-serif'].join(',');
export const filterFont = IS_ADMIN ? '16px/1.428 Source Sans Pro' : '14px/1.428 Source Sans Pro';
export const headerFont = IS_ADMIN ? '16px' : '14px';
export const formlabelFont = '18px';
export const subTitle = IS_ADMIN ? '16px' : '14px';
export const titleLabel = '20px';
export const buttonFont = '22px';
export const inputFont = '18px';
export const checkboxFont = '18px';
export const addbuttonFont = '20px';
export const companyDataFont = '20px';
export const iftaReport = IS_ADMIN ? '18px' : '15px';
export const inspectionInput = IS_ADMIN ? '19px' : '17px';
export const inspectionresolution = IS_ADMIN ? '16px' : '14px';
